// eslint-disable-next-line import/prefer-default-export
export const feeDiscounts = {
  namespaced: true,
  state: {
    feeDiscounts: [],
    appliedDiscounts: [],
    searchResults: [],
  },
  mutations: {
    setFeeDiscounts(state, data) {
      state.feeDiscounts = data
    },
    addFeeDiscount: (state, feeDiscount) => {
      state.feeDiscounts = [feeDiscount, ...state.feeDiscounts]
    },
    updateFeeDiscount: (state, feeDiscount) => {
      state.feeDiscounts = state.feeDiscounts.map(datum => {
        if (datum.id === feeDiscount.id) {
          return feeDiscount
        }
        return datum
      })
    },
    removeFeeDiscount: (state, id) => {
      state.feeDiscounts = state.feeDiscounts.filter(datum => datum.id !== id)
    },
    setAppliedDiscounts(state, data) {
      state.appliedDiscounts = data
    },
    addAppliedDiscount: (state, appliedDiscount) => {
      state.appliedDiscounts = [appliedDiscount, ...state.appliedDiscounts]
    },
    addMultipleAppliedDiscounts: (state, appliedDiscounts) => {
      state.appliedDiscounts = [...appliedDiscounts, ...state.appliedDiscounts]
    },
    removeAppliedDiscount: (state, id) => {
      state.appliedDiscounts = state.appliedDiscounts.filter(datum => datum.id !== id)
    },
    setSearchResults(state, data) {
      state.searchResults = data
    },
  },
  getters: {
    feeDiscounts(state) {
      return state.feeDiscounts
    },
    appliedDiscounts(state) {
      return state.appliedDiscounts
    },
    searchResults(state) {
      return state.searchResults
    },
  },
} 